export default "__VITE_ASSET__D4YZrw1B__"